module.exports = __webpack_public_path__ + "img/levercraft.73926790.jpg";